const apiConstant = {
  comment: {
    comment: "comments/",
  },
}
export default apiConstant
